const communityFilterConstants = {
  UPDATE_PRODUCT_LIST: "UPDATE_PRODUCT_LIST",
  UPDATE_STATUSES_LIST: "UPDATE_STATUSES_LIST",
};

export default communityFilterConstants;